<template>
  <el-dialog
    title="Seleccionar servicio a agregar"
    width="20%"
    :visible.sync="dialogFormVisible"
    @close="onCloseServicesSelector($event)"
  >
    <!-- <h1>Hello services dialog</h1> -->

    <el-form
      :model="ServiceSelectorform"
      :rules="rules"
      ref="serviceSelectorform"
    >
      <!--
    <el-form-item label="Promotion name" :label-width="formLabelWidth">
      <el-input v-model="form.name" autocomplete="off"></el-input>
    </el-form-item>
    -->

      <el-form-item label="Servicios: " prop="ServiceSelected">
        <el-select
          v-model="ServiceSelectorform.ServiceSelected"
          placeholder="Servicio a seleccionar"
        >
          <el-option
            v-for="item in Services"
            :key="item.ServiceCode"
            :label="item.ServiceName"
            :value="item.ServiceCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="dialogFormVisible = false"
        :disabled="DisabblingButtons"
        >Cancel</el-button
      >
      <el-button
        type="primary"
        @click="AddServiceToInactivate"
        :disabled="DisabblingButtons"
        >Confirm</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
//import { type } from 'os';

export default {
  name: "ServicesSelector",
  props: {
    makeServicesSelectorVisible: {
      type: Boolean,
      default: false
    },
    authorizerData: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      dialogFormVisible: false,
      DisabblingButtons: false,
      Services: [],
      ServiceSelectorform: {
        ServiceSelected: ""
      },
      rules: {
        ServiceSelected: [
          {
            required: true,
            message: "Favor seleccione el servicio a agregar",
            trigger: "change"
          }
        ]
      },
      AuthorizerData: []
    };
  },
  mounted() {
    //this.GetSemaphoreServices();
  },
  methods: {
    async GetSemaphoreServices() {
      //console.log("llamada a la api");
      this.$http.get("/api/tennos/GetSemaphoreServices").then((resp) => {
        /*
        console.log("GetSemaphoreServices resp: ", resp);
        console.log(
          "SemaphoreData: ",
          this.AuthorizerData.map((ad) => ad.ServiceName)
        );
        */
        this.Services = resp.data.filter(
          (s) =>
            !this.AuthorizerData.map((ad) => ad.ServiceName).includes(
              s.ServiceName
            )
        );
        //console.log("Services: ", this.Services);
        this.$emit("ServicesCount", this.Services.length);
      });
    },
    onCloseServicesSelector(/*event*/) {
      //console.log("el evento: ", event);
      this.$refs.serviceSelectorform.resetFields();
      this.$emit("OnCloseServicesSelector", false);
    },
    AddServiceToInactivate() {
      this.$refs.serviceSelectorform.validate((valid) => {
        //console.log("Validacion: ", valid);
        if (valid) {
          /*
          this.$confirm(
            `Esta a punto de inactivar el servicio ${this.ServiceSelectorform.ServiceSelected},
                        \n el mismo quedara desactivado hasta que se vuelva a reactivar.\n Desea continuar?`,
            "Cuidado",
            {
              confirmButtonText: "Continuar",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          )
            .then(() => {
              */
          this.DisabblingButtons = true;
          /*
              this.actualRowData.Actived = false;
              this.actualRowData.InactiveAt = new Date();
              (this.actualRowData.MessageTerminal =
                this.InactivationForm.terminalsMessage),
                (this.actualRowData.Reason =
                  this.InactivationForm.inactivateReason);
                  */

          const params = {
            ServiceName: this.ServiceSelectorform.ServiceSelected,
            CreateAt: new Date(),
            Actived: false,
            InactiveAt: null,
            MessageTerminal: null,
            Reason: null
          };

          try {
            this.$http
              .post("/api/tennos/InactivateAuthorizerService", params)
              .then(() => {
                //console.log("resp del put: ", resp);
                this.$message({
                  type: "success",
                  message: `Servicio  ${this.ServiceSelectorform.ServiceSelected} inactivado con exito`
                });
                this.dialogFormVisible = false;
              })
              .catch((err) => {
                console.error("error al inactivar servicio: ", err);
                //console.log("error data: ", err);
                this.DisabblingButtons = false;
              })
              .finally(() => {
                this.$emit("rechargingServices");
              });
          } catch (e) {
            console.error("error data try catch:  ", e);
          }
          /*
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: `ha cancelado la inactivacion del servicio  ${this.ServiceSelectorform.ServiceSelected}`
              });
            });
            */
          //console.log("Fue validado con exito");
          //console.log("InactivateService form: ", this.InactivationForm);
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    makeServicesSelectorVisible(val) {
      this.dialogFormVisible = val;
      this.DisabblingButtons = !val;
      if (val) {
        this.GetSemaphoreServices();
      }
    },
    authorizerData(val) {
      this.AuthorizerData = val;
    }
  }
};
</script>

<style scoped></style>
